/**
 * Text/number input primitive (PHASE1 §7.4) — a styled `<input>` that forwards
 * all native props and a ref (React 19 ref-as-prop).
 */
import type { InputHTMLAttributes, Ref } from 'react';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
};

export function Input({ className, invalid, ref, ...props }: InputProps) {
  return (
    <input
      ref={ref}
      className={`w-full rounded-md border bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 transition-colors duration-150 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500 ${
        invalid
          ? 'border-rose-400 focus:border-rose-500 dark:border-rose-500/60'
          : 'border-slate-200 focus:border-sky-600 dark:border-slate-700 dark:focus:border-sky-500'
      } ${className ?? ''}`}
      {...props}
    />
  );
}
